export default class OutletAction {
    static OUTLET_PROGRAM_REQUEST = 'OUTLET_PROGRAM_REQUEST';
    static OUTLET_PROGRAM_SUCCESS = 'OUTLET_PROGRAM_SUCCESS';
    static OUTLET_PROGRAM_FAILED = 'OUTLET_PROGRAM_FAILED';


    static outletProgram_Request() {
        return {
            type: this.OUTLET_PROGRAM_REQUEST
        }
    }

    static outletProgram_Success (data) {
        return {
            type: this.OUTLET_PROGRAM_SUCCESS,
            data
        }
    }

    static outletProgram_Failed (error) {
        return {
            type: this.OUTLET_PROGRAM_FAILED,
            error
        }
    }

    // LOCATION TYPE

    static LOCATION_TYPE_REQUEST = 'LOCATION_TYPE_REQUEST';
    static LOCATION_TYPE_SUCCESS = 'LOCATION_TYPE_SUCCESS';
    static LOCATION_TYPE_FAILED = 'LOCATION_TYPE_FAILED';

    static locationType_Request() {
        return {
            type: this.LOCATION_TYPE_REQUEST
        }
    }

    static locationType_Success (data) {
        return {
            type: this.LOCATION_TYPE_SUCCESS,
            data
        }
    }

    static locationType_Failed (error) {
        return {
            type: this.LOCATION_TYPE_FAILED,
            error
        }
    }

    // TIER

    static TIER_REQUEST = 'TIER_REQUEST';
    static TIER_SUCCESS = 'TIER_SUCCESS';
    static TIER_FAILED = 'TIER_FAILED';

    static tier_Request() {
        return {
            type: this.TIER_REQUEST
        }
    }

    static tier_Success (data) {
        return {
            type: this.TIER_SUCCESS,
            data
        }
    }

    static tier_Failed (error) {
        return {
            type: this.TIER_FAILED,
            error
        }
    }

     // PERFECT VILLAGE

     static PERFECT_VILLAGE_REQUEST = 'PERFECT_VILLAGE_REQUEST';
     static PERFECT_VILLAGE_SUCCESS = 'PERFECT_VILLAGE_SUCCESS';
     static PERFECT_VILLAGE_FAILED = 'PERFECT_VILLAGE_FAILED';
 
     static perfectVillage_Request() {
         return {
             type: this.PERFECT_VILLAGE_REQUEST
         }
     }
 
     static perfectVillage_Success (data) {
         return {
             type: this.PERFECT_VILLAGE_SUCCESS,
             data
         }
     }
 
     static perfectVillage_Failed (error) {
         return {
             type: this.PERFECT_VILLAGE_FAILED,
             error
         }
     }
     
    // CHANNEL TTS

     static CHANNEL_TTS_REQUEST = 'CHANNEL_TTS_REQUEST';
     static CHANNEL_TTS_SUCCESS = 'CHANNEL_TTS_SUCCESS';
     static CHANNEL_TTS_FAILED = 'CHANNEL_TTS_FAILED'; 
 
     static channelTts_Request() {
         return {
             type: this.CHANNEL_TTS_REQUEST
         }
     }
 
     static channelTts_Success (data) {
         return {
             type: this.CHANNEL_TTS_SUCCESS,
             data
         }
     }
 
     static channelTts_Failed (error) {
         return {
             type: this.CHANNEL_TTS_FAILED,
             error
         }
     }
 
         // CHAIN OUTLETS
 
     static CHAIN_OUTLETS_REQUEST = 'CHAIN_OUTLETS_REQUEST';
     static CHAIN_OUTLETS_SUCCESS = 'CHAIN_OUTLETS_SUCCESS';
     static CHAIN_OUTLETS_FAILED = 'CHAIN_OUTLETS_FAILED';
 
     static chainOutlets_Request() {
         return {
             type: this.CHAIN_OUTLETS_REQUEST
         }
     }
 
     static chainOutlets_Success (data) {
         return {
             type: this.CHAIN_OUTLETS_SUCCESS,
             data
         }
     }
 
     static chainOutlets_Failed (error) {
         return {
             type: this.CHAIN_OUTLETS_FAILED,
             error
         }
     }
 
     // PERFECT STORE
 
     static PERFECT_STORE_REQUEST = 'PERFECT_STORE_REQUEST';
     static PERFECT_STORE_SUCCESS = 'PERFECT_STORE_SUCCESS';
     static PERFECT_STORE_FAILED = 'PERFECT_STORE_FAILED';
 
     static perfectStore_Request() {
         return {
             type: this.PERFECT_STORE_REQUEST
         }
     }
 
     static perfectStore_Success (data) {
         return {
             type: this.PERFECT_STORE_SUCCESS,
             data
         }
     }
 
     static perfectStore_Failed (error) {
         return {
             type: this.PERFECT_STORE_FAILED,
             error
         }
     }
 
      // PERFECT STORE COMPLIANCE
 
      static PERFECT_STORE_COMPLIANCE_REQUEST = 'PERFECT_STORE_COMPLIANCE_REQUEST';
      static PERFECT_STORE_COMPLIANCE_SUCCESS = 'PERFECT_STORE_COMPLIANCE_SUCCESS';
      static PERFECT_STORE_COMPLIANCE_FAILED = 'PERFECT_STORE_COMPLIANCE_FAILED';
  
      static perfectStoreCompliane_Request() {
          return {
              type: this.PERFECT_STORE_COMPLIANCE_REQUEST
          }
      }
  
      static perfectStoreCompliane_Success (data) {
          return {
              type: this.PERFECT_STORE_COMPLIANCE_SUCCESS,
              data
          }
      }
  
      static perfectStoreCompliane_Failed (error) {
          return {
              type: this.PERFECT_STORE_COMPLIANCE_FAILED,
              error
          }
      }
      // OUTLET CLASSIFICATION
 
      static OUTLET_CLASSIFICATION_REQUEST = 'OUTLET_CLASSIFICATION_REQUEST';
      static OUTLET_CLASSIFICATION_SUCCESS = 'OUTLET_CLASSIFICATION_SUCCESS';
      static OUTLET_CLASSIFICATION_FAILED = 'OUTLET_CLASSIFICATION_FAILED';
  
      static outletClassification_Request() {
          return {
              type: this.OUTLET_CLASSIFICATION_REQUEST
          }
      }
  
      static outletClassification_Success (data) {
          return {
              type: this.OUTLET_CLASSIFICATION_SUCCESS,
              data
          }
      }
  
      static outletClassification_Failed (error) {
          return {
              type: this.OUTLET_CLASSIFICATION_FAILED,
              error
          }
      }

     // RANGE
 
     static RANGE_REQUEST = 'RANGE_REQUEST';
     static RANGE_SUCCESS = 'RANGE_SUCCESS';
     static RANGE_FAILED = 'RANGE_FAILED';
 
     static range_Request() {
         return {
             type: this.RANGE_REQUEST
         }
     }
 
     static range_Success (data) {
         return {
             type: this.RANGE_SUCCESS,
             data
         }
     }
 
     static range_Failed (error) {
         return {
             type: this.RANGE_FAILED,
             error
         }
     }

    // POINT OF CONSUMPTION

    static POINT_OF_CONSUMPTION_REQUEST = 'POINT_OF_CONSUMPTION_REQUEST';
    static POINT_OF_CONSUMPTION_SUCCESS = 'POINT_OF_CONSUMPTION_SUCCESS';
    static POINT_OF_CONSUMPTION_FAILED = 'POINT_OF_CONSUMPTION_FAILED';

    static pointOfConsumption_Request() {
        return {
            type: this.POINT_OF_CONSUMPTION_REQUEST
        }
    }

    static pointOfConsumption_Success (data) {
        return {
            type: this.POINT_OF_CONSUMPTION_SUCCESS,
            data
        }
    }

    static pointOfConsumption_Failed (error) {
        return {
            type: this.POINT_OF_CONSUMPTION_FAILED,
            error
        }
    }

     // LOYALITY PROGRAM

     static LOYALITY_PROGRAM_REQUEST = 'LOYALITY_PROGRAM_REQUEST';
     static LOYALITY_PROGRAM_SUCCESS = 'LOYALITY_PROGRAM_SUCCESS';
     static LOYALITY_PROGRAM_FAILED = 'LOYALITY_PROGRAM_FAILED';
 
     static loyalityProgram_Request() {
         return {
             type: this.LOYALITY_PROGRAM_REQUEST
         }
     }
 
     static loyalityProgram_Success (data) {
         return {
             type: this.LOYALITY_PROGRAM_SUCCESS,
             data
         }
     }
 
     static loyalityProgram_Failed (error) {
         return {
             type: this.LOYALITY_PROGRAM_FAILED,
             error
         }
     }

      // CUSTOMER ATTRIBUTE

    static CUSTOMER_ATTRIBUTE_REQUEST = 'CUSTOMER_ATTRIBUTE_REQUEST';
    static CUSTOMER_ATTRIBUTE_SUCCESS = 'CUSTOMER_ATTRIBUTE_SUCCESS';
    static CUSTOMER_ATTRIBUTE_FAILED = 'CUSTOMER_ATTRIBUTE_FAILED';

    static customerAttribute_Request() {
        return {
            type: this.CUSTOMER_ATTRIBUTE_REQUEST
        }
    }

    static customerAttribute_Success (data) {
        return {
            type: this.CUSTOMER_ATTRIBUTE_SUCCESS,
            data
        }
    }

    static customerAttribute_Failed (error) {
        return {
            type: this.CUSTOMER_ATTRIBUTE_FAILED,
            error
        }
    }

    // OUTLET SUMMARY

  static OUTLET_SUMMARY_REQUEST = 'OUTLET_SUMMARY_REQUEST';
  static OUTLET_SUMMARY_SUCCESS = 'OUTLET_SUMMARY_SUCCESS';
  static OUTLET_SUMMARY_FAILED = 'OUTLET_SUMMARY_FAILED';

  static outletSummary_Request() {
      return {
          type: this.OUTLET_SUMMARY_REQUEST
      }
  }

  static outletSummary_Success (data) {
      return {
          type: this.OUTLET_SUMMARY_SUCCESS,
          data
      }
  }

  static outletSummary_Failed (error) {
      return {
          type: this.OUTLET_SUMMARY_FAILED,
          error
      }
  }

  // EXCLUDE OUTLET FILTER

static EXCLUDE_OUTLET_FILTER_REQUEST = 'EXCLUDE_OUTLET_FILTER_REQUEST';
static EXCLUDE_OUTLET_FILTER_SUCCESS = 'EXCLUDE_OUTLET_FILTER_SUCCESS';
static EXCLUDE_OUTLET_FILTER_FAILED = 'EXCLUDE_OUTLET_FILTER_FAILED';

static excludeOutletFilter_Request() {
    return {
        type: this.EXCLUDE_OUTLET_FILTER_REQUEST
    }
}

static excludeOutletFilter_Success (data) {
    return {
        type: this.EXCLUDE_OUTLET_FILTER_SUCCESS,
        data
    }
}

static excludeOutletFilter_Failed (error) {
    return {
        type: this.EXCLUDE_OUTLET_FILTER_FAILED,
        error
    }
}

// EXCLUDE OUTLET FROM SUMMARY

static EXCLUDE_OUTLET_FROM_SUMMARY_REQUEST = 'EXCLUDE_OUTLET_FROM_SUMMARY_REQUEST';
static EXCLUDE_OUTLET_FROM_SUMMARY_SUCCESS = 'EXCLUDE_OUTLET_FROM_SUMMARY_SUCCESS';
static EXCLUDE_OUTLET_FROM_SUMMARY_FAILED = 'EXCLUDE_OUTLET_FROM_SUMMARY_FAILED';

static excludeOutletFromSummary_Request() {
  return {
      type: this.EXCLUDE_OUTLET_FROM_SUMMARY_REQUEST
  }
}

static excludeOutletFromSummary_Success (data) {
  return {
      type: this.EXCLUDE_OUTLET_FROM_SUMMARY_SUCCESS,
      data
  }
}

static excludeOutletFromSummary_Failed (error) {
  return {
      type: this.EXCLUDE_OUTLET_FROM_SUMMARY_FAILED,
      error
  }
}

// GET EXCLUDE OUTLET FOR APPROVAL SCREEN

static GET_EXCLUDE_OUTLET_REQUEST = 'GET_EXCLUDE_OUTLET_REQUEST';
static GET_EXCLUDE_OUTLET_SUCCESS = 'GET_EXCLUDE_OUTLET_SUCCESS';
static GET_EXCLUDE_OUTLET_FAILED = 'GET_EXCLUDE_OUTLET_FAILED';

static excludeOutletForApproval_Request() {
  return {
      type: this.GET_EXCLUDE_OUTLET_REQUEST
  }
}

static excludeOutletForApproval_Success (data) {
  return {
      type: this.GET_EXCLUDE_OUTLET_SUCCESS,
      data
  }
}

static excludeOutletForApproval_Failed (error) {
  return {
      type: this.GET_EXCLUDE_OUTLET_FAILED,
      error
  }
}
}